import { api } from "@/lib/api";
import type { PaginatedResponse } from "@/types/common/api-types";
import type {
  Service,
  ServiceCreate,
  ServiceUpdate,
  ServiceSearchParams,
} from "../../types/services/api-types/service-types";

export const serviceApi = {
  async getServices(
    params: ServiceSearchParams = {}
  ): Promise<PaginatedResponse<Service>> {
    const response = await api.get<PaginatedResponse<Service>>("/services", {
      params,
    });
    return response.data;
  },

  async getService(id: number): Promise<Service> {
    const response = await api.get<Service>(`/services/${id}`);
    return response.data;
  },

  async createService(data: ServiceCreate): Promise<Service> {
    const response = await api.post<Service>("/services", data);
    return response.data;
  },

  async updateService(id: number, data: ServiceUpdate): Promise<Service> {
    const response = await api.put<Service>(`/services/${id}`, data);
    return response.data;
  },

  async deleteService(id: number): Promise<void> {
    await api.delete(`/services/${id}`);
  },
};
